// extracted by mini-css-extract-plugin
module.exports = {"noChecks":"style_noChecks__2qgkM"};